import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import layoutALLReducer from "./layoutReducer"
//IndexImportHygen
const allLayoutReducers = combineReducers({
    isResultReducer,
    layoutALLReducer,
    //IndexUsingHygen
})

export default allLayoutReducers;